<template>
  <div
    data-testid="player-video-abrir"
    @click="toggleDialogVideo"
    class="cursor-pointer"
  >
    <PlayerIcon />

    <q-dialog
      v-model="showDialogVideo"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card
        class="column"
        :style="`width: ${widthDialog}; max-width: ${widthDialog}; height: ${heightDialog}; max-height: ${heightDialog}; margin-top: 35px`"
      >
        <q-card-section>
          <div
            class="video-player"
            :style="`height: ${heightVideo}`"
          >
            <q-inner-loading
              v-if="isLoading"
              :showing="true"
            >
              <q-spinner-ios
                size="30px"
                color="primary"
              />
            </q-inner-loading>

            <q-media-player
              v-else
              id="bottomControls"
              bottom-controls
              :sources="sources"
              :hide-fullscreen-btn="true"
              type="video"
              ref="qmp"
              dense
              preload="none"
              background-color="white"
              color="primary"
              :style="`height: ${heightVideo}; max-height: ${heightVideo}; max-width: ${widthVideo}; width: ${widthVideo}; text-align: center`"
            >
              <div
                slot="settings"
                class="row items-center q-mr-xs q-ml-xs"
              >
                <q-btn
                  data-testid="player-video-velocidade"
                  flat
                  icon="mdi-play-speed"
                  color="primary"
                  dense
                  size="sm"
                  v-if="url"
                >
                  <q-tooltip>Velocidade</q-tooltip>
                  <q-menu
                    separate-close-popup
                    dense
                  >
                    <q-list
                      style="min-width: 100px"
                      dense
                    >
                      <q-item
                        clickable
                        v-close-popup
                      >
                        <q-item-section
                          data-testid="player-video-velocidade-05"
                          @click="$refs.qmp.__playbackRateChanged(0.5)"
                        >
                          0,5x
                        </q-item-section>
                      </q-item>

                      <q-item
                        clickable
                        v-close-popup
                      >
                        <q-item-section
                          data-testid="player-video-velocidade-1"
                          @click="$refs.qmp.__playbackRateChanged(1.0)"
                        >
                          1x
                        </q-item-section>
                      </q-item>

                      <q-item
                        clickable
                        v-close-popup
                      >
                        <q-item-section
                          data-testid="player-video-velocidade-15"
                          @click="$refs.qmp.__playbackRateChanged(1.5)"
                        >
                          1,5x
                        </q-item-section>
                      </q-item>

                      <q-item
                        clickable
                        v-close-popup
                      >
                        <q-item-section
                          data-testid="player-video-velocidade-2"
                          @click="$refs.qmp.__playbackRateChanged(2.0)"
                        >
                          2x
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-menu>
                </q-btn>

                <q-space v-if="url" />

                <q-btn
                  data-testid="player-video-download"
                  v-if="url"
                  @click="download"
                  flat
                  dense
                  size="sm"
                  icon="mdi-download"
                  color="primary"
                >
                  <q-tooltip>Download do Arquivo</q-tooltip>
                </q-btn>

                <q-btn
                  data-testid="player-video-copiar-link"
                  v-if="url"
                  @click="clipboard"
                  flat
                  dense
                  size="sm"
                  icon="mdi-link-variant"
                  color="primary"
                >
                  <q-tooltip>Copiar link do arquivo</q-tooltip>
                </q-btn>
              </div>
            </q-media-player>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QMediaPlayer } from '@quasar/quasar-ui-qmediaplayer'
import api from '@/libs/api'
import Helpers from '@/libs/helpers'
import { checkURL } from '@/libs/hasURL'
import PlayerIcon from '@/assets/icons/PlayerIcon.svg'
import { Screen } from 'quasar'
const ipcRenderer = window.ipcRenderer

export default {
  components: {
    PlayerIcon,
    QMediaPlayer
  },

  data () {
    const widthVideo = '100vh'
    const heightVideo = '100vh'

    const widthDialog = '100vh'
    const heightDialog = '100vh'

    return {
      widthDialog,
      heightDialog,

      widthVideo,
      heightVideo,

      isLoading: true,
      showDialogVideo: false
    }
  },

  props: {
    url: {},
    name: {},
    mime: {}
  },

  computed: {
    sources () {
      return [{
        src: this.url,
        type: this.mime,
        name: this.name
      }]
    }
  },

  mounted () {
    const vm = this
    vm.isMounted = true
    vm.calcArea()
  },

  beforeDestroy () {
    const vm = this
    vm.isMounted = false
  },

  methods: {
    toggleDialogVideo () {
      const vm = this
      if (vm.showDialogVideo) return

      checkURL(vm, vm.url)

      vm.calcArea()
      vm.showDialogVideo = true
    },

    calcArea () {
      const vm = this
      vm.widthDialog = `${Screen.width - 48}px`
      vm.heightDialog = String(Number(Screen.height) - (24 * 2) - 35).concat('px')

      vm.widthVideo = `${Screen.width - 48 - 36}px`
      vm.heightVideo = String(Number(Screen.height) - (24 * 2) - 35 - 36).concat('px')
    },

    async download () {
      const downloadUrl = await api.getDownloadUrl(this.url)
      if (!downloadUrl) return

      ipcRenderer.send('download', { payload: { url: downloadUrl, name: this.name } })
    },

    clipboard () {
      Helpers.copy(this, this.url, 'Link copiado!')
    },

    notify (message, color = 'primary') {
      this.$q.notify({
        color: color,
        icon: null,
        position: 'center',
        timeout: 2000,
        progress: true,
        html: true,
        message
      })
    }
  }
}
</script>

<style lang="sass">
  .video-player
    position: relative
    min-height: 30px

    .q-media--big-button
      display: none

    .q-menu .q-media
      width: 400px
      border-width: 0.1rem
      border-style: solid
      border-color: #1769B6
      .q-btn
        font-size: 10px

    #bottomControls .q-media__controls
      font-size: 12px

    .q-media__controls--button
      font-size: 12px !important

    .q-slider__track
      height: 2px !important

    .q-slider__thumb
      width: 14px !important
      height: 14px !important

    .q-media__controls--video-time-text svg:not(:root)
        width: 16px !important
</style>
